import type { ReactNode } from 'react';

export interface MetadataEntry {
  label: string;
  value: ReactNode;
}

interface MetadataGridProps {
  entries: readonly MetadataEntry[];
}

/** Label-Wert-Paare, durch Haarlinien getrennt. Das Label ist klein, der Wert fett. */
export function MetadataGrid({ entries }: MetadataGridProps) {
  return (
    <dl className="metadata-grid">
      {entries.map((entry) => (
        <div key={entry.label} className="metadata-grid__item">
          <dt className="metadata-grid__label">{entry.label}</dt>
          <dd className="metadata-grid__value">{entry.value}</dd>
        </div>
      ))}
    </dl>
  );
}
